import React from 'react'
import { Navigate } from 'react-router-dom'
import { RoutePaths } from '@assembly/constants'

export default function Invoices() {
    // Redirect to Billing (which will redirect to Usage Billing)
    return <Navigate to={RoutePaths.Billing} replace />
}
